import React, { useEffect, useState } from "react";
import { Card, Row, Col, Typography, Spin } from "antd";
import { useSelector } from "react-redux";
import {
  ReloadOutlined,
  SearchOutlined,
  FileTextOutlined,
  PushpinOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import tenderDashboardApis from "../../api/tenderDashboard/tenderDashboardApis";

const { Title, Text } = Typography;

const summaryItems = [
  {
    key: "underEvaluation",
    icon: <SearchOutlined />,
    title: "Under Evaluation",
  },
  {
    key: "tendersPublished",
    icon: <FileTextOutlined />,
    title: "Tenders Published",
  },
  {
    key: "activeTenders",
    icon: <PushpinOutlined />,
    title: "Active Tenders",
  },
  {
    key: "avgBiddersPerTender",
    icon: <TeamOutlined />,
    title: "Avg. Bidders / Tender",
  },
  {
    key: "pendingEvaluations",
    icon: <ClockCircleOutlined />,
    title: "Pending Evaluations",
  },
  {
    key: "tendersAwarded",
    icon: <CheckCircleOutlined />,
    title: "Tenders Awarded",
  },
  {
    key: "awardedValue",
    icon: <DollarOutlined />,
    title: "Awarded Value",
    format: (value: number) => `₹ ${(value ?? 0).toLocaleString("en-IN")}`,
  },
];

const mapApiToUi = (row: any) => ({
  underEvaluation: row?.tendersUnderEvaluation ?? 0,
  tendersPublished: row?.tendersPublished ?? 0,
  activeTenders: row?.activeTenders ?? 0,
  avgBiddersPerTender: row?.avgBidPerTender ?? 0,
  pendingEvaluations: row?.pendingEvaluation ?? 0,
  tendersAwarded: row?.tendersAwarded ?? 0,
  awardedValue: row?.totalAwardedValue ?? 0,
});

const TenderSummaryWidget: React.FC = () => {
  const currentUser = useSelector((state: any) => state.currentUser?.data);
  const orgId = currentUser?.orgid;

  const [data, setData] = useState<any>(mapApiToUi(null));
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    if (!orgId) return;
    setLoading(true);
    try {
      const res = await tenderDashboardApis.getTenderSummary({
        orgIds: String(orgId),
      });
      const row = res?.data?.data?.[0];
      setData(mapApiToUi(row));
    } catch (e) {
      setData(mapApiToUi(null));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  return (
    <Card
      title={
         <div style={{ padding: '10px 0' }}>
          <Title level={5} style={{ marginBottom: 0, color: "#004293" }}>
            Summary
          </Title>
          <Text type="secondary" style={{ fontSize: 12, color: '#8094ae' }}>
            Snapshot of current tender lifecycle statistics
          </Text>
        </div>
      }
      extra={
        <ReloadOutlined onClick={fetchData} style={{ cursor: "pointer" }} />
      }
      style={{ width: "100%"}}
      bodyStyle={{ padding: "10px" }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin tip="Loading..." />
        </div>
      ) : (
        summaryItems.map((item, index) => {
          const value = data[item.key as keyof typeof data];
          const formattedValue = item.format ? item.format(value) : value;

          return (
            <div
              key={item.key}
              style={{
                backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                padding: "10px 14px",
                cursor: "pointer",
              }}
              onClick={() => console.log(`Navigate to: ${item.title}`)}
            >
              <Row align="middle" gutter={10} wrap={false}>
                <Col>{item.icon}</Col>
                <Col flex="auto">
                  <Text strong style={{ fontSize: 14 }}>
                    {item.title}
                  </Text>
                </Col>
                <Col>
                  <Text style={{ fontSize: 18, color: "#467abf" }}>
                    {formattedValue}
                  </Text>
                </Col>
              </Row>
            </div>
          );
        })
      )}
    </Card>
  );
};

export default TenderSummaryWidget;
